import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

export function NotificationIndicator({
  className = '',
}: {
  className?: string;
}) {
  return <span role="status" className={clsx(className, styles.indicator)} />;
}
